// extracted by mini-css-extract-plugin
export default {"applePayContainer":"AdyenApplePayButton-module__applePayContainer--e669e","applePayRoundBorder":"AdyenApplePayButton-module__applePayRoundBorder--Wl3oH"};